import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { ToastService } from '@projects/shared/src/app/services/toast/toast.service';
import { getType } from '@projects/shared/src/app/utils/helper';

@Component({
  selector: 'app-recovery-code',
  templateUrl: './recovery-code.component.html',
  styleUrls: ['./recovery-code.component.sass'],
})
export class RecoveryCodeComponent implements OnInit {
  code: string;
  authData: any;

  constructor(private router: Router, private authService: AuthenticationService, private toastService: ToastService) {
    this.code = '-------';
  }

  ngOnInit(): void {
    this.authData = this.authService.authData;
    if (this.authData) {
      this.code = this.authData.RecoveryCode;
    }
  }

  onContinue() {
    this.authData.RecoveryCode = '';
    localStorage.removeItem('isRedirectFromMultiAuthPage');
    console.log(
      new Date().toLocaleString() +
        ' ➤ recovery-code.component.ts ➤ onContinue(): [line 29] ==> Setting authData , type = ' +
        getType(this.authData)
    );
    localStorage.setItem('authorizationData', JSON.stringify(this.authData));
    console.log(new Date().toLocaleString() + '  ➤  Auth data updated on recovery code onContinue => ', this.authData);
    this.authService.setAuthData(this.authData);
    this.router.navigate(['/']);
  }

  public downloadPDF(): void {
    const line1 = 'FleCX';
    const line2 = 'Put this code in a safe place.';
    const line3 = "If you lose your device and don't have the recovery code,";
    const line4 = 'you will lose access to your account.';
    const line5 = 'Recovery Code: ' + this.code;

    // Multi-line stream content using proper Td (positioning) and Tj (text show)
    const streamContent = `
  BT
  /F1 16 Tf
  72 770 Td
  (${line1}) Tj
  /F1 12 Tf
  72 -30 Td
  (${line2}) Tj
  0 -20 Td
  (${line3}) Tj
  0 -20 Td
  (${line4}) Tj
  /F1 14 Tf
  0 -30 Td
  (${line5}) Tj
  ET`;

    const contentLength = streamContent.length;

    const pdfContent = `%PDF-1.3
  1 0 obj
  << /Type /Catalog /Pages 2 0 R >>
  endobj
  2 0 obj
  << /Type /Pages /Kids [3 0 R] /Count 1 >>
  endobj
  3 0 obj
  << /Type /Page /Parent 2 0 R /MediaBox [0 0 595 842] /Contents 4 0 R /Resources << /Font << /F1 5 0 R >> >> >>
  endobj
  4 0 obj
  << /Length ${contentLength} >>
  stream
  ${streamContent}
  endstream
  endobj
  5 0 obj
  << /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>
  endobj
  xref
  0 6
  0000000000 65535 f 
  0000000010 00000 n 
  0000000061 00000 n 
  0000000115 00000 n 
  0000000206 00000 n 
  0000000300 00000 n 
  trailer
  << /Root 1 0 R /Size 6 >>
  startxref
  ${206 + contentLength + 22}
  %%EOF`;

    const blob = new Blob([pdfContent], { type: 'application/pdf' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'FleCX-Recovery-Code.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    this.toastService.success(`The recovery code has been downloaded.`);
  }

  public copyCode() {
    navigator.clipboard.writeText(this.code);
    this.toastService.success(`The recovery code has been copied.`);
  }
}
